import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStarred = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8901_12693)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.0103 41.9896V24.4606C15.0103 19.7549 18.0645 17.4639 21.8253 19.3451C25.5872 21.2274 28.6404 26.5748 28.6404 31.2805V79.5L25.2329 77.7945V29.8591C25.2329 27.5067 23.7063 24.8325 21.8253 23.8914C19.9444 22.9503 18.4178 24.0968 18.4178 26.4491V43.693L15.0103 41.9896Z",
				fill: "#5472E4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M28.6415 31.2805C28.6415 26.5748 25.5873 21.2274 21.8264 19.3451C20.2181 18.5409 18.7395 18.499 17.5734 19.0825L53.9218 0.895452C55.0879 0.31197 56.5665 0.353866 58.1748 1.15807C61.9367 3.04034 64.9899 8.38875 64.9899 13.0934V61.3129L46.8157 56.7667L28.6415 79.5V31.2805Z",
				fill: "#9EB1FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M25.2329 40.2841L18.4178 43.694V26.4501C18.4178 24.0978 19.9444 22.9513 21.8254 23.8924C23.7063 24.8336 25.2329 27.5078 25.2329 29.8601V40.2841Z",
				fill: "#253974"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M46.4273 21.9966L49.6496 29.8883L57.0751 27.5832L51.6414 37.5034L53.0083 47.1583L46.4273 45.3976L39.8475 53.6695L41.2145 42.6618L35.7808 38.1185L43.2049 33.0763L46.4273 21.9966Z",
				fill: "#5472E4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M40.9468 54.2202L42.3137 43.2125L36.88 38.6692L44.3054 33.627L47.5278 22.5473L50.5898 24.0794L47.3675 35.1591L39.9433 40.2013L45.377 44.7446L44.0101 55.7523L40.9468 54.2202Z",
				fill: "#8F6424"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M52.9124 29.767L58.1744 28.1339L61.2377 29.666L53.8123 31.9711L52.9124 29.767Z",
				fill: "#FFD60A"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M50.5899 24.0793L53.8122 31.971L61.2377 29.6659L55.804 39.5861L57.1709 49.2411L50.5899 47.4804L44.0101 55.7522L45.3771 44.7445L39.9434 40.2012L47.3675 35.159L50.5899 24.0793Z",
				fill: "#FFC53D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M36.88 38.6692L39.9433 40.2013L45.377 44.7446L42.3137 43.2124L36.88 38.6692Z",
				fill: "#8F6424"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M44.3054 33.627L47.3675 35.1591L39.9433 40.2013L36.88 38.6692L44.3054 33.627Z",
				fill: "#FFD60A"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8901_12693",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 49.9796,
			height: 79,
			fill: "white",
			transform: "translate(15.0103 0.5)"
		})
	}) })]
});
export default SvgEmptyStarred;
